"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.yearUpdate = exports.yearList = exports.yearDelete = exports.resourceTypeUpdate = exports.resourceTypeList = exports.resourceTypeDelete = exports.resourceLibraryUpdate = exports.resourceLibraryList = exports.resourceLibraryDelete = exports.propertyUpdate = exports.propertyList = exports.propertyDelete = exports.projectUpdate = exports.projectList = exports.projectDelete = exports.mediaTypeUpdate = exports.mediaTypeListAll = exports.mediaTypeList = exports.mediaTypeDelete = exports.industryUpdate = exports.industryList = exports.industryDelete = exports.courseLevelUpdate = exports.courseLevelList = exports.courseLevelDelete = exports.applicationTypeUpdate = exports.applicationTypeListAll = exports.applicationTypeList = exports.applicationTypeDelete = void 0;
var _api = _interopRequireDefault(require("_l/api.request"));
var _qs = _interopRequireDefault(require("qs"));
//产业分类 分页列表
var industryList = exports.industryList = function industryList(data) {
  return _api.default.request({
    url: '/industryClassification/getList',
    method: 'post',
    data: data
  });
};

//产业分类 新增
var industryUpdate = exports.industryUpdate = function industryUpdate(data) {
  return _api.default.request({
    url: '/industryClassification/insertOrUpdateIndustryClassification',
    method: 'post',
    data: data
  });
};

//产业分类 删除
var industryDelete = exports.industryDelete = function industryDelete(data) {
  return _api.default.request({
    url: '/industryClassification/deleteIndustryClassification',
    method: 'post',
    data: data
  });
};

//行业门类 分页列表
var propertyList = exports.propertyList = function propertyList(data) {
  return _api.default.request({
    url: '/industryCategory/getList',
    method: 'post',
    data: data
  });
};

//行业门类 新增/修改
var propertyUpdate = exports.propertyUpdate = function propertyUpdate(data) {
  return _api.default.request({
    url: '/industryCategory/insertOrUpdateIndustryCategory',
    method: 'post',
    data: data
  });
};

//行业门类 删除
var propertyDelete = exports.propertyDelete = function propertyDelete(data) {
  return _api.default.request({
    url: '/industryCategory/deleteIndustryCategory',
    method: 'post',
    data: data
  });
};

//项目级别 分页列表
var projectList = exports.projectList = function projectList(data) {
  return _api.default.request({
    url: '/projectLevel/getList',
    method: 'post',
    data: data
  });
};

//项目级别 新增/修改
var projectUpdate = exports.projectUpdate = function projectUpdate(data) {
  return _api.default.request({
    url: '/projectLevel/insertOrUpdateProjectLevel',
    method: 'post',
    data: data
  });
};

//项目级别 删除
var projectDelete = exports.projectDelete = function projectDelete(data) {
  return _api.default.request({
    url: '/projectLevel/deleteProjectLevel',
    method: 'post',
    data: data
  });
};

//资源库类型 分页列表
var resourceTypeList = exports.resourceTypeList = function resourceTypeList(data) {
  return _api.default.request({
    url: '/resourceType/getList',
    method: 'post',
    data: data
  });
};

//资源库类型 新增/修改
var resourceTypeUpdate = exports.resourceTypeUpdate = function resourceTypeUpdate(data) {
  return _api.default.request({
    url: '/resourceType/insertOrUpdateResourceType',
    method: 'post',
    data: data
  });
};

//资源库类型 删除
var resourceTypeDelete = exports.resourceTypeDelete = function resourceTypeDelete(data) {
  return _api.default.request({
    url: '/resourceType/deleteResourceType',
    method: 'post',
    data: data
  });
};

//资源库分类 分页列表
var resourceLibraryList = exports.resourceLibraryList = function resourceLibraryList(data) {
  return _api.default.request({
    url: '/professionalResourceLibraryType/getList',
    method: 'post',
    data: data
  });
};

//资源库分类 新增/修改
var resourceLibraryUpdate = exports.resourceLibraryUpdate = function resourceLibraryUpdate(data) {
  return _api.default.request({
    url: '/professionalResourceLibraryType/insertOrUpdateProfessionalResourceLibraryType',
    method: 'post',
    data: data
  });
};

//资源库分类 删除
var resourceLibraryDelete = exports.resourceLibraryDelete = function resourceLibraryDelete(data) {
  return _api.default.request({
    url: '/professionalResourceLibraryType/deleteProfessionalResourceLibraryType',
    method: 'post',
    data: data
  });
};

//层次管理 分页列表
var courseLevelList = exports.courseLevelList = function courseLevelList(data) {
  return _api.default.request({
    url: '/courseLevel/getList',
    method: 'post',
    data: data
  });
};

//层次管理 新增/修改
var courseLevelUpdate = exports.courseLevelUpdate = function courseLevelUpdate(data) {
  return _api.default.request({
    url: '/courseLevel/insertOrUpdateCourseLevel',
    method: 'post',
    data: data
  });
};

//层次管理 删除
var courseLevelDelete = exports.courseLevelDelete = function courseLevelDelete(data) {
  return _api.default.request({
    url: '/courseLevel/deleteCourseLevel',
    method: 'post',
    data: data
  });
};

//年份管理 分页列表
var yearList = exports.yearList = function yearList(data) {
  return _api.default.request({
    url: '/year/getList',
    method: 'post',
    data: data
  });
};

//年份管理 新增/修改
var yearUpdate = exports.yearUpdate = function yearUpdate(data) {
  return _api.default.request({
    url: '/year/insertOrUpdateYear',
    method: 'post',
    data: data
  });
};

//年份管理 删除
var yearDelete = exports.yearDelete = function yearDelete(data) {
  return _api.default.request({
    url: '/year/deleteYear',
    method: 'post',
    data: data
  });
};

//应用类型 分页列表
var applicationTypeList = exports.applicationTypeList = function applicationTypeList(data) {
  return _api.default.request({
    url: '/applicationType/getList',
    method: 'post',
    data: data
  });
};

//应用类型 新增/修改
var applicationTypeUpdate = exports.applicationTypeUpdate = function applicationTypeUpdate(data) {
  return _api.default.request({
    url: '/applicationType/insertOrUpdateApplicationType',
    method: 'post',
    data: data
  });
};

//应用类型 删除
var applicationTypeDelete = exports.applicationTypeDelete = function applicationTypeDelete(data) {
  return _api.default.request({
    url: '/applicationType/deleteApplicationType',
    method: 'post',
    data: data
  });
};

//媒体类型 分页列表
var mediaTypeList = exports.mediaTypeList = function mediaTypeList(data) {
  return _api.default.request({
    url: '/mediaType/getList',
    method: 'post',
    data: data
  });
};

//媒体类型 新增/修改
var mediaTypeUpdate = exports.mediaTypeUpdate = function mediaTypeUpdate(data) {
  return _api.default.request({
    url: '/mediaType/insertOrUpdateMediaType',
    method: 'post',
    data: data
  });
};

//媒体类型 删除
var mediaTypeDelete = exports.mediaTypeDelete = function mediaTypeDelete(data) {
  return _api.default.request({
    url: '/mediaType/deleteMediaType',
    method: 'post',
    data: data
  });
};

// 应用类型 查询全部
var applicationTypeListAll = exports.applicationTypeListAll = function applicationTypeListAll(data) {
  return _api.default.request({
    url: '/applicationType/getListAll',
    method: 'post',
    data: data
  });
};

// 媒体类型 查询全部
var mediaTypeListAll = exports.mediaTypeListAll = function mediaTypeListAll(data) {
  return _api.default.request({
    url: '/mediaType/getListAll',
    method: 'post',
    data: data
  });
};